import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CustomCursor from './components/CustomCursor';
import ExperienceSection from './components/ExperienceSection';
import HeroSection from './components/HeroSection';
import LandingScreen from './components/LandingScreen';
import RouteMetadata from './components/RouteMetadata';
import SmoothScroll from './components/SmoothScroll';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import ProjectDetail from './pages/ProjectDetail';
import { LanguageProvider } from './i18n/LanguageContext';
import './App.css';

const MainHome = () => (
  <SmoothScroll>
    <main>
      <HeroSection />
      <AboutSection />
      <ExperienceSection />
      <ContactSection />
    </main>
  </SmoothScroll>
);

function App() {
  const [showLanding, setShowLanding] = useState(true);

  return (
    <LanguageProvider>
      <div className="app-container relative">
        <CustomCursor />
        <AnimatePresence>
          {showLanding && (
            <LandingScreen onComplete={() => setShowLanding(false)} />
          )}
        </AnimatePresence>

        {!showLanding && (
          <BrowserRouter>
            <RouteMetadata />
            <Routes>
              <Route path="/" element={<MainHome />} />
              <Route path="/projekte/:slug" element={<ProjectDetail />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
          </BrowserRouter>
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
